import React, { useState, useEffect, useContext } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { AppContext } from "../../AppContext";

import { isSteward } from "../../common/checkClient";
import PreTradeFormEquity from "./PreTradeFormEquity";
import PreTradeFormBond from "./PreTradeFormBond";
import PreTradeFormOption from "./PreTradeFormOption";
import PreTradeFormMutualFund from "./PreTradeFormMutualFund";
import PreTradeFormAltInvest from "./PreTradeFormAltInvest";
import PreTradeFormPrivateInvestment from "./PreTradeFormPrivateInvestment";

const PreTradeForm = (props) => {
    const [appContext, setAppContext] = useContext(AppContext);

    const enabledSecTypes = JSON.parse(appContext.appFeature.EMP_PRETRADE_REQUEST_SECURITY_TYPES);
    const steward = isSteward();

    const [securityType, setsecurityType] = useState(props.data.securityType);

    const [validation, setValidation] = useState({
        valid: true,
        securitySymbol: true,
        securityDesc: true,
        quantity: true,
        accountNumber: true,
        finInstituteId: true,
        tradeAction: true,
        tradeDate: true,
        orderType: true,
        account: true,
        optionRestriction: true,
        dollarAmount: true,
        liquidationAmount: true,
        investState: true,

        businessName: true,
        businessDesc: true,
        ownershipShares: true,
        isOwnershipBeneficial: true,
        ownershipPercent: true,
        isPassiveInvestor: true,
        passiveInvolvement: true,
        isClientInvolve: true,
        clientInvolvement: true,
        businessKnowledgeSource: true,
        isPublicBusiness: true,
        publicTradeEntity: true,
        isBusinessCustody: true,
        businessCustody: true,
        isCapitalRaise: true,
        capitalRaiseDesc: true,
        compensationMethod: true,
        custodiedInvestment: true,
        attachments: true
    });


    const validate = () => {
        const valid =
            props.data.tradeDate &&
                (props.data.securityDesc || (securityType === "PrivateInvestment")) &&
                (props.data.accountNumber || (securityType === "PrivateInvestment")) &&
                (props.data.finInstituteId || (securityType === "PrivateInvestment")) &&
                props.data.tradeAction ||
                (
                    (securityType === "PrivateInvestment") ||
                    (securityType === "Equity" && (props.data.tradeAction === "B" || props.data.tradeAction === "S" || props.data.tradeAction === "SS")) ||
                    (securityType === "Option" && (props.data.tradeAction === "BO" || props.data.tradeAction === "BC" || props.data.tradeAction === "SO" || props.data.tradeAction === "SC")) ||
                    ((securityType === "Bond" || securityType === "MutualFund" || securityType === "Alternative") && (props.data.tradeAction === "B" || props.data.tradeAction === "S"))
                )

                &&
                (securityType === "Option" || securityType === 'PrivateInvestment' || props.data.securitySymbol) &&
                ((securityType === "MutualFund" && props.data.tradeAction === "B") || securityType === "Alternative" || securityType === "PrivateInvestment" || props.data.quantity) &&
                (securityType !== "Option" || props.data.optionRestriction) &&
                (securityType === "Equity" || securityType === "Bond" || securityType === "Option" || (securityType === "MutualFund" && props.data.tradeAction !== "B") || (securityType === "Alternative" && props.data.tradeAction === "S") || props.data.dollarAmount) &&
                (securityType !== "Alternative" || (securityType === "Alternative" && (props.data.tradeAction === "B" || (props.data.tradeAction === "S" && props.data.liquidationAmount)))) &&
                ((securityType !== "Alternative") || (securityType === "Alternative" && props.data.tradeAction !== "B") || props.data.investState) &&

                (securityType !== 'PrivateInvestment' || props.data.businessName) &&
                (securityType !== 'PrivateInvestment' || props.data.businessDesc) &&
                (!steward || securityType !== 'PrivateInvestment' || props.data.ownershipShares) &&
                (!steward || securityType !== 'PrivateInvestment' || props.data.isOwnershipBeneficial || (securityType === 'PrivateInvestment' && props.data.ownershipShares !== '')) &&
                (steward || securityType !== 'PrivateInvestment' || props.data.ownershipPercent) &&
                (securityType !== 'PrivateInvestment' || props.data.isPassiveInvestor) &&
                (securityType !== 'PrivateInvestment' || props.data.passiveInvolvement || (securityType === 'PrivateInvestment' && props.data.isPassiveInvestor !== 'Yes')) &&
                (securityType !== 'PrivateInvestment' || props.data.isClientInvolve) &&
                (securityType !== 'PrivateInvestment' || props.data.clientInvolvement || (securityType === 'PrivateInvestment' && props.data.isClientInvolve !== 'Yes')) &&
                (securityType !== 'PrivateInvestment' || props.data.businessKnowledgeSource) &&
                (securityType !== 'PrivateInvestment' || props.data.isPublicBusiness) &&
                (securityType !== 'PrivateInvestment' || props.data.publicTradeEntity || (securityType === 'PrivateInvestment' && props.data.isPublicBusiness !== 'Yes')) &&
                (securityType !== 'PrivateInvestment' || props.data.isBusinessCustody) &&
                (securityType !== 'PrivateInvestment' || props.data.businessCustody || (securityType === 'PrivateInvestment' && props.data.isBusinessCustody !== 'Yes')) &&
                (steward || securityType !== 'PrivateInvestment' || props.data.isCapitalRaise) &&
                (steward || securityType !== 'PrivateInvestment' || props.data.compensationMethod) &&
                (securityType !== 'PrivateInvestment' || props.data.capitalRaiseDesc || (securityType === 'PrivateInvestment' && props.data.isCapitalRaise !== 'Yes')) &&
                (securityType !== 'PrivateInvestment' || props.data.custodiedInvestment)
                ? true
                : false;

        setValidation({
            ...validation,
            valid,
            tradeDate: props.data.tradeDate ? true : false,
            securityDesc: (props.data.securityDesc || (securityType === "PrivateInvestment")) ? true : false,
            accountNumber: (props.data.accountNumber || (securityType === "PrivateInvestment")) ? true : false,
            finInstituteId: (props.data.finInstituteId || (securityType === "PrivateInvestment")) ? true : false,
            securitySymbol: (securityType === "Option" || securityType === 'PrivateInvestment' || props.data.securitySymbol) ? true : false,
            quantity: ((securityType === "MutualFund" && props.data.tradeAction === "B") || securityType === "Alternative" || securityType === 'PrivateInvestment' || props.data.quantity) ? true : false,
            tradeAction: (
                (securityType === 'PrivateInvestment') ||
                (securityType === "Equity" && (props.data.tradeAction === "B" || props.data.tradeAction === "S" || props.data.tradeAction === "SS")) ||
                (securityType === "Option" && (props.data.tradeAction === "BO" || props.data.tradeAction === "BC" || props.data.tradeAction === "SO" || props.data.tradeAction === "SC")) ||
                ((securityType === "Bond" || securityType === "MutualFund" || securityType === "Alternative") && (props.data.tradeAction === "B" || props.data.tradeAction === "S"))
            ) ? true : false,
            account: (props.data.account || (securityType === 'PrivateInvestment')) ? true : false,
            optionRestriction: (securityType !== "Option" || props.data.optionRestriction) ? true : false,
            dollarAmount: (securityType === "Equity" || securityType === "Bond" || securityType === "Option" || (securityType === "MutualFund" && props.data.tradeAction !== "B") || (securityType === "Alternative" && props.data.tradeAction === "S") || props.data.dollarAmount) ? true : false,
            liquidationAmount: (securityType !== "Alternative" || (securityType === "Alternative" && (props.data.tradeAction === "B" || (props.data.tradeAction === "S" && props.data.liquidationAmount)))) ? true : false,
            investState: (securityType !== "Alternative") || (securityType === "Alternative" && props.data.tradeAction !== "B") || props.data.investState ? true : false,

            businessName: (securityType !== 'PrivateInvestment' || props.data.businessName) ? true : false,
            businessDesc: (securityType !== 'PrivateInvestment' || props.data.businessDesc) ? true : false,
            ownershipShares: (securityType !== 'PrivateInvestment' || props.data.ownershipShares) ? true : false,
            isOwnershipBeneficial: (securityType !== 'PrivateInvestment' || props.data.isOwnershipBeneficial) ? true : false,
            ownershipPercent: (securityType !== 'PrivateInvestment' || props.data.ownershipPercent) ? true : false,
            isPassiveInvestor: (securityType !== 'PrivateInvestment' || props.data.isPassiveInvestor) ? true : false,
            passiveInvolvement: (securityType !== 'PrivateInvestment' || props.data.passiveInvolvement || (securityType === 'PrivateInvestment' && props.data.isPassiveInvestor !== 'Yes')) ? true : false,
            isClientInvolve: (securityType !== 'PrivateInvestment' || props.data.isClientInvolve) ? true : false,
            clientInvolvement: (securityType !== 'PrivateInvestment' || props.data.clientInvolvement || (securityType === 'PrivateInvestment' && props.data.isClientInvolve !== 'Yes')) ? true : false,
            businessKnowledgeSource: (securityType !== 'PrivateInvestment' || props.data.businessKnowledgeSource) ? true : false,
            isPublicBusiness: (securityType !== 'PrivateInvestment' || props.data.isPublicBusiness) ? true : false,
            publicTradeEntity: (securityType !== 'PrivateInvestment' || props.data.publicTradeEntity || (securityType === 'PrivateInvestment' && props.data.isPublicBusiness !== 'Yes')) ? true : false,
            isBusinessCustody: (securityType !== 'PrivateInvestment' || props.data.isBusinessCustody) ? true : false,
            businessCustody: (securityType !== 'PrivateInvestment' || props.data.businessCustody || (securityType === 'PrivateInvestment' && props.data.isBusinessCustody !== 'Yes')) ? true : false,
            isCapitalRaise: (securityType !== 'PrivateInvestment' || props.data.isCapitalRaise) ? true : false,
            capitalRaiseDesc: (securityType !== 'PrivateInvestment' || props.data.capitalRaiseDesc || (securityType === 'PrivateInvestment' && props.data.isCapitalRaise !== 'Yes')) ? true : false,
            compensationMethod: (securityType !== 'PrivateInvestment' || props.data.compensationMethod) ? true : false,
            custodiedInvestment: (securityType !== 'PrivateInvestment' || props.data.custodiedInvestment) ? true : false
        });


        return valid;
    };

    const handleSecurityTypeChange = (secType) => {
        setsecurityType(secType);
    };



    const handleSaveClick = (e) => {
        if (!validate()) {
            return;
        }
        props.handleSaveClick(e);
    };


    useEffect(() => {
        props.handleChange({ target: { name: "securityType", value: securityType } })
    }, [securityType])

    // useEffect(() => {
    //     console.log(validation);
    // }, [validation])



    return (
        <div className="form">
            <div className="form-header">
                <div className="form-header-label">Create a New Pre-Trade Request</div>
            </div>
            <div className="form-body">

                <div className="flex-vcenter">
                    <label className="mr-3">Select Security Type :</label>
                    <div className="mt-4 mb-4">
                        <div className="switch">
                            {enabledSecTypes['Equity'] &&
                                <div className={`switch-item ${securityType === "Equity" ? "selected" : ""}`} onClick={() => handleSecurityTypeChange("Equity")}>
                                    <div className="switch-item-content">Equity</div>
                                </div>
                            }
                            {enabledSecTypes['Bond'] &&
                                <div className={`switch-item ${securityType === "Bond" ? "selected" : ""}`} onClick={() => handleSecurityTypeChange("Bond")}>
                                    <div className="switch-item-content">Bond</div>
                                </div>
                            }
                            {enabledSecTypes['Option'] &&
                                <div className={`switch-item ${securityType === "Option" ? "selected" : ""}`} onClick={() => handleSecurityTypeChange("Option")}>
                                    <div className="switch-item-content">Option</div>
                                </div>
                            }
                            {enabledSecTypes['MutualFund'] &&

                                <div className={`switch-item ${securityType === "MutualFund" ? "selected" : ""}`} onClick={() => handleSecurityTypeChange("MutualFund")}>
                                    <div className="switch-item-content">Mutual Fund</div>
                                </div>
                            }
                            {enabledSecTypes['Alternative'] &&
                                <div className={`switch-item ${securityType === "Alternative" ? "selected" : ""}`} onClick={() => handleSecurityTypeChange("Alternative")}>
                                    <div className="switch-item-content">Alternative</div>
                                </div>
                            }
                            {enabledSecTypes['PrivateInvestment'] &&
                                <div className={`switch-item ${securityType === "PrivateInvestment" ? "selected" : ""}`} onClick={() => handleSecurityTypeChange("PrivateInvestment")}>
                                    <div className="switch-item-content">Private Investment</div>
                                </div>
                            }

                        </div>
                    </div>
                </div>



                {securityType === "Equity" && <PreTradeFormEquity
                    metadata={props.metadata}
                    data={props.data}
                    validation={validation}
                    handleChange={props.handleChange}
                    handleDateChange={props.handleDateChange}
                    handleAccountSelectionChanged={props.handleAccountSelectionChanged}
                />}

                {securityType === "Bond" && <PreTradeFormBond
                    metadata={props.metadata}
                    data={props.data}
                    validation={validation}
                    handleChange={props.handleChange}
                    handleDateChange={props.handleDateChange}
                    handleAccountSelectionChanged={props.handleAccountSelectionChanged}
                />}

                {securityType === "Option" && <PreTradeFormOption
                    metadata={props.metadata}
                    data={props.data}
                    validation={validation}
                    handleChange={props.handleChange}
                    handleDateChange={props.handleDateChange}
                    handleAccountSelectionChanged={props.handleAccountSelectionChanged}
                />}

                {securityType === "MutualFund" && <PreTradeFormMutualFund
                    metadata={props.metadata}
                    data={props.data}
                    validation={validation}
                    handleChange={props.handleChange}
                    handleDateChange={props.handleDateChange}
                    handleAccountSelectionChanged={props.handleAccountSelectionChanged}
                />}
                {securityType === "Alternative" && <PreTradeFormAltInvest
                    metadata={props.metadata}
                    data={props.data}
                    validation={validation}
                    handleChange={props.handleChange}
                    handleDateChange={props.handleDateChange}
                    handleAccountSelectionChanged={props.handleAccountSelectionChanged}
                />}

                {securityType === "PrivateInvestment" && <PreTradeFormPrivateInvestment
                    metadata={props.metadata}
                    data={props.data}
                    validation={validation}
                    handleChange={props.handleChange}
                    handleDateChange={props.handleDateChange}
                    handleAccountSelectionChanged={props.handleAccountSelectionChanged}
                    handleAttachmentChange={props.handleAttachmentChange}
                />}

            </div>
            <div className="form-footer">
                {validation.valid ? (<div className="form-status"></div>) : (<div className="form-status error">Enter Required Information</div>)}
                <div className="btn-group">
                    <button id="btnCancel" type="button" className="btn btn-primary-outline" onClick={props.handleCancel}>Cancel</button>
                    <button id="btnReview" type="button" className="btn btn-primary" onClick={handleSaveClick}>Save and Review</button>
                </div>
            </div>
        </div>
    );
};

export default PreTradeForm;
